import Child from "./Child";
import Heading from "./Heading";
import useAccordionContext from "./helpers/useAccordionContext";
import Item from "./Item";
import Wrapper from "./Wrapper";
export var Accordion = {
  Wrapper: Wrapper,
  Item: Item,
  Heading: Heading,
  Child: Child
};
export { useAccordionContext };
export default Accordion;